import * as React from 'react';
import { ClassNames } from '@emotion/react';
import { Colors } from '../../../theme/Colors.es.js';
import { Typography } from '../../../theme/Typography.es.js';

function WithDayPickerStyle({ children, size }) {
  return React.createElement(ClassNames, null, ({ css }) => children({
    classNames: {
      body: css`
              display: table-row-group;
            `,
      caption: css`
              color: ${Colors.neutral800};
              margin: 0 0 1em 0;
              text-align: center;
              ${Typography.paragraph3Bold}
            `,
      container: css`
              display: flex;
              justify-content: center;
              position: relative;
              user-select: none;

              &:after,
              &:before {
                border: solid transparent;
                bottom: 100%;
                content: ' ';
                display: block;
                height: 0;
                left: 10%;
                pointer-events: none;
                position: absolute;
                width: 0;
              }

              &:after {
                border-bottom-color: ${Colors.neutral800};
                border-color: rgba(136, 183, 213, 0);
                border-width: 8px;
                margin-left: -8px;
              }

              &:before {
                border-bottom-color: ${Colors.neutral800};
                border-color: rgba(194, 225, 245, 0);
                border-width: 8px;
                margin-left: -8px;
              }

              abbr {
                ${Typography.smallPrint3Semibold}
                text-decoration: none;
              }

              div[role='columnheader'] > abbr {
                font-size: 14px;
                font-weight: 700;
                line-height: 20px;
                text-transform: uppercase;
              }
            `,
      day: css`
              border: none;
              cursor: pointer;
              display: table-cell;
              padding: 0.8rem 0.7rem;
              text-align: center;
              vertical-align: middle;
              ${Typography.paragraph3}

              &:hover {
                background-color: ${Colors.neutral200};
                border-radius: 10px;
              }
            `,
      interactionDisabled: css`
              .DayPicker-Day {
                cursor: default;
              }
            `,
      // @ts-ignore This is valid, but the types don't reflect it: https://react-day-picker.js.org/api/DayPicker/
      month: css`
              border-collapse: collapse;
              border-spacing: 0;
              padding: 2.5em 1em 1em 0em;
              user-select: none;
              ${size !== "small" ? `
                &:last-of-type {
                  border-left: 1px solid ${Colors.neutral300};
                  padding: 2.5em 0em 1em 1em;
                }
              ` : ""}
              ${size === "small" && "padding: 2.5em 0em 1em 0em;"}
            `,
      // @ts-ignore This is valid, but the types don't reflect it: https://react-day-picker.js.org/api/DayPicker/
      months: css`
              display: flex;
            `,
      navBar: "",
      navButtonNext: "",
      navButtonPrev: "",
      navButtonInteractionDisabled: "",
      footer: "",
      todayButton: "",
      week: css`
              display: table-row;
            `,
      weekNumber: "",
      weekday: css`
              display: table-cell;
              font-size: 0.875em;
              padding: 0.8rem 0.7rem;
              text-align: center;
              ${Typography.smallPrint3Bold}
            `,
      weekdays: css`
              display: table-header-group;

              > div {
                display: table-row;
              }
            `,
      weekdaysRow: "",
      wrapper: css`
              display: flex;
              position: relative;
            `,
      // Modifiers
      outside: css`
              color: ${Colors.neutral500};
              cursor: default;
            `,
      selected: css`
              background-color: ${Colors.blue10};
              color: ${Colors.blue};
              font-weight: 600;
            `,
      today: css`
              color: ${Colors.neutral800};
              font-weight: 700;
            `,
      disabled: css`
              background-color: ${Colors.neutral200};
              color: ${Colors.neutral600};
              cursor: not-allowed;
              outline: none;
            `
    },
    modifiersStyles: {
      from: {
        borderBottomLeftRadius: 10,
        borderTopLeftRadius: 10
      },
      to: {
        borderBottomRightRadius: 10,
        borderTopRightRadius: 10
      }
    }
  }));
}

export { WithDayPickerStyle };
//# sourceMappingURL=WithDayPickerStyle.es.js.map
